module.exports = __webpack_public_path__ + "static/local-listing-2b0ac9529b049d58709cf497d8570f79.png";